import { combineReducers } from 'redux';
import appReducer from './appReducer';
import fetchReducer from './fetchReducer';
import currentProviderReducer from './currentProviderReducer';

export default combineReducers({
  app: appReducer,
  providers: fetchReducer('PROVIDERS'),
  providerDetails: fetchReducer('PROVIDER_DETAILS'),
  providerResourceFiles: fetchReducer('PROVIDER_RESOURCE_FILES'),
  currentProviderContent: currentProviderReducer,
  providerResourceNews: fetchReducer('PROVIDER_RESOURCE_NEWS')
});
